import { PureComponent } from "react";

import ProtoTypes from 'prop-types';
import { Container, Segment } from "semantic-ui-react";
import moment from 'moment';
import { loadFile, renderMDFile } from "../../utils/markdownUtil";
import _ from "lodash";
import Empty from "../empty";
import './Blog.css';

class Blog extends PureComponent {
    state = {
        blogData: ""
    }
    componentDidMount() {
        this.updateData();
    }
    componentDidUpdate() {
        this.updateData();
    }

    updateData() {
        const { data } = this.props;
        const { download_url, name } = data || {};
        if (_.isEmpty(name)) return;
        // const gitlabFileUrl = "https://gitlab.com/yungkei/blogs/-/raw/main/" + name;
        // const gitlabFileUrl = "api-gitlab/yungkei/blogs/-/raw/main/" + name;
        // loadFile(gitlabFileUrl).then((data) => {
        //     this.setState({ blogData: data })
        // });

        // loadFile(download_url).then((data) => {
        //     this.setState({ blogData: data })
        // });

        const filePath = "/data/blogs/" + name;
        loadFile(filePath).then((data) => {
            this.setState({ blogData: data })
        });
    }

    render() {
        const { blogData } = this.state
        return <Segment className="Blog" >
            <Container textAlign='justified' attached>
                {
                    _.isEmpty(blogData) ? <Empty></Empty> : renderMDFile(blogData)
                }
            </Container>
        </Segment>
    }
}

Blog.protoTypes = {
    author: ProtoTypes.string,
    title: ProtoTypes.string,
    date: ProtoTypes.string,
    desc: ProtoTypes.string,
    content: ProtoTypes.object,
    data: ProtoTypes.any
}

Blog.defaultProps = {
    author: 'yungkei',
    date: moment.now
}

export default Blog;